module.exports = __webpack_public_path__ + "static/media/draw-polygon.17d65040.svg";